import { render } from "./EditarPerfil.vue?vue&type=template&id=bbfc66d4&scoped=true"
import script from "./EditarPerfil.vue?vue&type=script&lang=js"
export * from "./EditarPerfil.vue?vue&type=script&lang=js"

import "./EditarPerfil.vue?vue&type=style&index=0&id=bbfc66d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbfc66d4"]])

export default __exports__